// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"4a997678","220":"9f556b67","420":"37414b5d","830":"b2ac890e","981":"d7429d93"}[chunkId] + ".chunk.js";
};